import { BarChartOutlined, LineChartOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { usePriceIndexChartStore } from '../../Store/hooks/useStore'

export const PriceIndexChartTypeSwitch = () => {
  const { chartType, setChartType } = usePriceIndexChartStore(state =>
    pick(state, ['chartType', 'setChartType'])
  )

  const handleClick = () => {
    setChartType(chartType === 'line' ? 'bar' : 'line')
  }

  const iconNode =
    chartType === 'line' ? <BarChartOutlined /> : <LineChartOutlined />

  return (
    <Tooltip title={chartType === 'line' ? '柱状图' : '折线图'}>
      <Button icon={iconNode} onClick={handleClick} />
    </Tooltip>
  )
}
